import { render, staticRenderFns } from "./CatalogItem.vue?vue&type=template&id=111b5f9a&scoped=true"
import script from "./CatalogItem.vue?vue&type=script&lang=js"
export * from "./CatalogItem.vue?vue&type=script&lang=js"
import style0 from "./CatalogItem.vue?vue&type=style&index=0&id=111b5f9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "111b5f9a",
  null
  
)

export default component.exports